<template>
  <v-card
    :loading="loading"
    elevation="0"
    tile
    dark
    color="primary"
    v-if="showBanner.active"
  >
    <v-row justify-center v-if="loading">
      <v-progress-circular
        :size="55"
        :width="4"
        indeterminate
        dark
        class="mt-4 mb-4 mx-auto"
      ></v-progress-circular>
    </v-row>
    <div v-if="!loading">
      <v-row class="ml-2">
        <v-card-title v-if="!showBanner.showPin">
          {{ $t("components.banners.retrofitBanner.informationRequired") }}
        </v-card-title>
        <v-card-title v-else>
          {{ $t("components.banners.retrofitBanner.thankYou") }}
        </v-card-title>
        <v-card-text class="mr-2" v-if="!showBanner.showPin">
          {{
            $t(
              "components.banners.retrofitBanner.whereWasTheBoatMonitorDeviceInstalled"
            )
          }}
        </v-card-text>
        <v-card-text class="mr-2" v-else>
          {{
            $t(
              "components.banners.retrofitBanner.activationCodeForSentinelBoatMonitorDevice"
            )
          }}
          <br />
          <span>
            <strong>{{ showBanner.pin }}</strong>
          </span>
        </v-card-text>
      </v-row>
      <v-row justify="end" class="mr-2 pb-1" v-if="!showBanner.showPin">
        <v-btn dark @click="setTypeOfInstallation('DENIED')" text>{{
          $t("components.banners.retrofitBanner.factory")
        }}</v-btn>
        <v-btn dark @click="setTypeOfInstallation('CONFIRMED')" text>{{
          $t("components.banners.retrofitBanner.retrofit")
        }}</v-btn>
      </v-row>
    </div>
    <warning-dialog
      :dialog="warningDialog.active"
      :text="warningDialog.text"
      :title="warningDialog.title"
      @agree="handleDialogResponse"
      v-show="false"
    />
  </v-card>
</template>
<script>
import snackbar from "@/utils/snackbar";
import api from "@/utils/api";
import WarningDialog from "@/components/dialogs/WarningDialog";
export default {
  components: {
    WarningDialog,
  },
  props: {
    showBanner: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      warningDialog: {
        active: false,
        text: "",
        title: "",
      },
      loading: false,
      typeOfInstallation: null,
    };
  },
  computed: {},
  methods: {
    handleDialogResponse(event) {
      if (event) {
        this.loading = true;
        api
          .setRetrofitStatus(this.$route.params.id, this.typeOfInstallation)
          .then((resp) => {
            if (Object.keys(resp.data.billing_info).length !== 0) {
              this.$emit("update:retrofit-banner", resp.data);
            } else {
              this.$emit("update:retrofit-banner", null);
              snackbar.success(
                this.$t("utils.snackbar.success.successfullySaved")
              );
            }
            this.loading = false;
          })
          .catch((err) => {
            console.error(err);
            snackbar.error();
            this.loading = false;
          });
      }
      this.warningDialog.active = false;
    },
    setTypeOfInstallation(type) {
      this.warningDialog.title = this.$t(
        "components.banners.retrofitBanner.pleaseConfirmYourSelection"
      );
      this.warningDialog.text =
        type === "CONFIRMED"
          ? this.$t("components.banners.retrofitBanner.retrofit")
          : this.$t("components.banners.retrofitBanner.factory");
      this.warningDialog.active = true;
      this.typeOfInstallation = type;
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
